import { API_JWT_BASE_URL } from '../http'

export const LOGIN_API = `${API_JWT_BASE_URL}/Users/login`
export const LOGOUT_API = `${API_JWT_BASE_URL}/Users/logout`
export const ADD_USER_API = `${API_JWT_BASE_URL}/Users`
export const CHANGE_PASSWORD_API = `${API_JWT_BASE_URL}/Users/changepassword`
export const REFRESH_TOKEN_API = `${API_JWT_BASE_URL}/Users/refreshtoken`
export const GET_PASSWORD_POLICY_API = `${API_JWT_BASE_URL}/Users/GetPasswordPolicy`

export const AUTH_QUERY_KEYS = {
  LOGIN_USER: 'LOGIN_USER',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  GET_PASSWORD_POLICY: 'GET_PASSWORD_POLICY'
}
